import React, { useState, useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import Alert from 'sweetalert2';
import AppContext from '../../appContext';
import Back from '../../main/back';
import LenteProntaLabChoose from './lente-pronta-lab-choose';
import { TokenUtils } from '../../shared/utils/TokenUtils';
import { redirectPage } from '../../components/utils/redirectpage';
import './lente-pronta-home.css';

const LenteProntaHome = () => {
	const context = useContext(AppContext);
	const [hasModuleAccess, setHasModuleAccess] = useState(false);
	const [userLabs, setUserLabs] = useState([]);
	const [redirectData, setRedirectData] = useState(null);

	useEffect(() => {
		redirectPage(sessionStorage.getItem('token'), '/lente-pronta');
		checkModuleAccess();
		extractLabsFromToken();
	}, []);

	const checkModuleAccess = () => {
		setHasModuleAccess(TokenUtils.hasModuloLentePronta());
	};

	const extractLabsFromToken = () => {
		const labs = TokenUtils.extractLabsFromToken() || [];
		setUserLabs(labs);
	};

	const checkHealth = (lab) => {
		context.showLoading('Validando laboratório');

		const requestOptions = {
			method: 'GET',
			headers: { laboratorio: lab.cnpj },
		};

		fetch(process.env.REACT_APP_ESSILOR_API + 'gestao-produtos-laboratorio/v1/health', requestOptions)
			.then(response => {
				if (response.ok) {
					return fetch(
						process.env.REACT_APP_ESSILOR_API + 'gestao-pedidos-laboratorio/v1/health',
						requestOptions,
					);
				}
				return Promise.reject(response);
			})
			.then(response => {
				if (response.ok) {
					context.hideLoading();
					setRedirectData(lab);
				} else {
					return Promise.reject(response);
				}
			})
			.catch(() => {
				context.hideLoading();
				Alert.fire({
					icon: 'warning',
					html: 'O serviço está temporariamente indisponível para este laboratório.<br /> O time do Essilor Conecta já está atuando para resolver o problema.',
					width: 'auto',
					title: 'Aviso',
					confirmButtonColor: '#00518b',
					customClass: { confirmButton: 'x-follow-order__filter-btn' },
				});
			});
	};

	const handleLabSelect = (lab) => {
		checkHealth(lab);
	};

	if (redirectData) {
		return (
			<Redirect
				to={{
					pathname: '/lente-pronta-pedido',
					state: {
						labCnpj: redirectData.cnpj,
						hasLaboratorio: redirectData.cnpj,
						laboratorio: redirectData,
					},
				}}
			/>
		);
	}

	if (!context.userSession) {
		return (
			<div id="main-body" className="container">
				<Back items={[{ label: 'Seleção de Laboratório' }]} title="Conecta Lente Pronta" />
				<div className="text-center mt-5">
					<h3>Carregando...</h3>
				</div>
			</div>
		);
	}

	if (!hasModuleAccess) {
		return (
			<div id="main-body" className="container">
				<Back items={[{ label: 'Seleção de Laboratório' }]} title="Conecta Lente Pronta" />
				<div className="text-center mt-5">
					<h3>Acesso Negado</h3>
					<p>Você não possui acesso ao módulo Lente Pronta.</p>
					<p className="text-muted">Entre em contato com o administrador para solicitar acesso.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="x-body lente-pronta-home" id="main-body">
			<main className=".x-web-ordering__main">
				<div className="x-web-ordering__container">
					<section className="x-web-ordering__left">
						<div>
							<Back items={[{ label: 'Seleção de Laboratório' }]} title="Conecta Lente Pronta" />
							{ userLabs.length > 0 && (
								<LenteProntaLabChoose
									onSelectLab={ handleLabSelect }
									userLabs={ userLabs }
								/>
							) }
						</div>
						<div className="x-web-ordering__intro">
							<img src="image/modulos/logo_conecta_lente_pronta.png" alt="Conecta Lente Pronta" className="guia-atacado-img" />
							<div className="x-web-ordering__intro--container">
								<p className="x-web-ordering__intro--subtitle">
									Dúvidas? Baixe nosso <a id="link-guia-download" href="#" target="_blank" rel="noopener noreferrer" className="x-web-ordering__intro--link x-web-ordering__intro--subtitle-bold">Guia do Conecta Lente Pronta</a>.
								</p>
							</div>
						</div>
					</section>
				</div>
			</main>
		</div>
	);
};

export default LenteProntaHome;
